/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { InputSearch } from "@nordcloud/gnui";
import { useQueryState } from "~/hooks";
import { isEmpty } from "~/tools";

type Props = {
  searchInput: string | undefined;
  setSearchInput: (input: string) => void;
  width?: string;
  disabled?: boolean;
};

export function SearchBoxContainer({
  searchInput = "",
  setSearchInput,
  width,
  disabled = false,
}: Props) {
  const { state, updateQueryState, setQueryState } = useQueryState();

  const setQuery = () => {
    if (isEmpty(searchInput)) {
      const { query: ignored, ...queryState } = state;
      setQueryState({ ...queryState, page: 0 });
      return;
    }
    updateQueryState({ query: searchInput, page: 0 });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setQuery();
    }
  };

  return (
    <InputSearch
      value={searchInput}
      placeholder="Search"
      name="search"
      css={{ width }}
      disabled={disabled}
      onKeyPress={handleKeyPress}
      onSearch={setQuery}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        setSearchInput(event.target.value)
      }
    />
  );
}
